<template>
  <!-- custom-form-common-category .cfcc -->
  <div class="cfcc">
    <div class="my-set z-select">
      <div class="my-set-l">{{fieldData.Value}}:</div>
      <div class="my-set-r">
        <div>
          <Input v-model="value" placeholder="输入品类" clearable style="width: 166px" />
          <span class="ms-add" @click="handleAdd()">添加</span>
        </div>
        <div class="ms-brand" v-if="tag && tag.length">
          <div class="ms-brand-item" v-for="(item, index) in tag" :key="'tag' + index">
            {{item.Value}}
            <img
              src="@/assets/img/exhibition/close.png"
              class="close"
              @click="handleClose(index)"
            />
          </div>
        </div> 
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  // 领域类型 - 代工品类
  name: "custom-form-common-category",
  props: {
    field: {
      type: Object,
      default: { List: [], TypeId: 3, Value: "代工品类" }
    }
  },
  model: {
    prop: "field",
    event: "sendField"
  },
  data() {
    return {
      fieldData: { List: [], TypeId: 3, Value: "代工品类" },
      tag: [],
      chooseTag: [
        // 选择的tag列表
      ],
      // 0=授权渠道
      // 1=招募地区
      // 2=服务范围
      // 3=代工品类
      // 4=擅长领域
      // 5=合作渠道
      // 8=服务地区
      type: 3,
      value: ""
    };
  },
  watch: {
    tag(val, oldVal) {
      if (val) {
        this.fieldData.List = this.tag;
        this.$emit("sendField", this.fieldData);
        this.$emit("refresh");
      }
    }
  },
  async created() {
    let data = await this.getActionType(this.type);
    if (data && data.length > 0) {
      this.tag = data;
    }
    this.init();
  },
  methods: {
    ...mapActions({
      getActionType: "companyModule/getActionType"
    }),
    init() {   
      if (this.field && this.field.List) {  
          this.tag = this.field.List;  
      }
    },
    handleAdd() {
      if (this.value) {
        this.tag.push({ TypeId: 3, Value: this.value });
        this.value = "";
      }
    },
    handleClose(index) {
      this.tag.splice(index, 1);
    }, 
  }
};
</script>

<style lang="scss">
.my-set {
  display: flex;
  margin-bottom: 20px;
  &-l {
    width: 84px;
    font-size: 14px;
    color: #333;
  }
  &-r {
    flex: 1;
  }
  .ms {
    &-add {
      line-height: 32px;
      padding: 0 20px;
      display: inline-block;
      cursor: pointer;
      color: #178fff;
    }
    &-brand {
      margin: 20px 0 0;
      &-item {
        min-width: 76px;
        padding: 0 10px;
        text-align: center;
        border-radius: 5px;
        border: solid 1px #178fff;
        color: #178fff;
        position: relative;
        display: inline-block;
        margin-right: 20px;
        margin-bottom: 20px;
      }
      .close {
        position: absolute;
        top: -8px;
        right: -8px;
        width: 16px;
        height: 16px;
        cursor: pointer;
      }
    }
  }
}
</style>
